// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfUnions_wrapper__6YoZU"};